<template>
  <div class="bg-black height-100 watch-info">
    <div class="main-polv" v-if="videoData">
      <div class="flex polv-tit">
        <div :span="12" class="flex align-center">
          <span class="schedule-name">{{ videoData.scheduleName }}</span>
        </div>
        <div :span="6" class="flex align-center">
          <div @click="goAsk()" class="flex align-center cursor" style="margin-right: 20px">
            <img src="./img/ask-icon.png" class="icon-play" />提问
          </div>
          <div @click="goEvaluate()" class="flex align-center cursor" v-if="isShowEva">
            <img src="./img/evaluate-icon.png" class="icon-play" />评价
          </div>
          <div class="header_title">
            <h1 class="icon_container">
              <div class="icon" v-if="userInfo.nickName">
                <img :src="userInfo.headImgUrl" alt="" class="stu-logo" />
              </div>
              <span>{{ userInfo.nickName }}</span>
            </h1>
          </div>
        </div>
      </div>
      <a-row class="panel-body" type="flex" justify="space-between">
        <a-col :span="18" class="left-panel height-100">
          <div id="live" class="live height-100">
            <div id="player" class="height-100 width-100"></div>
          </div>
        </a-col>
        <a-col :span="6" class="hide-pagination height-100 flex-column">
          <div class="relative bg-dark-black plv-watch-pc height-100">
            <div class="box">
              <div id="chat" class="width-100"><chat></chat></div>
              <resource
                :pushType="videoData.pushType"
                :classesName="videoData.classesName"
                v-if="videoData.activityStatus !== 0"
                :activityInfo="videoData"
                :planclassesId="studentData.planclassesId"
                @getResorce="getResorce"
                :resourceList="resourceList"
              ></resource>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <ask-modal :visible.sync="askVisible" @refresh="refresh"></ask-modal>
    <evaluate-modal
      :visible.sync="evaluateVisible"
      @refresh="evaluatRefresh"
      :scheduleId="studentData.scheduleId"
    ></evaluate-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import resource from '../watchLiveV2/module/resource'
import askModal from '../watchLiveV2/module/askModal'
import evaluateModal from '@/components/evaluateModal/evaluateModal'
import chat from './module/chat'
export default {
  components: { resource, askModal, evaluateModal, chat },
  data() {
    return {
      studentData: {},
      videoData: {},
      lastWatchTime: 0,
      polyvWatchTimer: null,
      polvLastWatchTime: 0,
      polvStartWatchTime: 0,
      userInfo: Vue.ls.get('USER_INFO'),
      resourceList: [],
      evaluateVisible: false,
      askVisible: false,
      isShowEva: false
    }
  },
  created() {
    if (this.$route.query) {
      this.studentData = this.$route.query
    }
    if (this.polyvWatchTimer) {
      clearInterval(this.polyvWatchTimer)
    }
    this.polyvWatchTimer = setInterval(() => {
      this.savePolyWatchTime()
    }, 60000)
    this.initData()
  },
  async mounted() {
    this.getStuVieoData()
    this.getResorce() // 初始化资源列表
  },
  computed: {},
  destroyed() {},
  methods: {
    initData() {
      this.userInfo = Vue.ls.get('USER_INFO')
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
      // console.log('scanBeginTime', parseInt(new Date().getTime()))
      this.scanBeginTime = parseInt(new Date().getTime())
    },
    // 获取视频/直播详情数据
    async getStuVieoData() {
      const res = await this.$http.post(
        `/b/classes/wxapp/schedule/v2/check/${this.studentData.classesId}/${this.studentData.scheduleId}`,
        { headers: { token: this.studentData.token } }
      )
      console.log(`获取视频/直播详情数据____________________`, res)
      const time = res
      if (time.startTime && time.endTime) {
        const start = time.startTime.split(' ')
        const end = time.endTime.split(' ')
        if (start[0] === end[0]) {
          res.end = end[1]
        } else {
          res.end = res.endTime
        }
      }
      this.videoData = res
      this.isShowEva = !res.hasComment
      const arr = []
      this.lastWatchTime = res.lastWatchTime
      console.log('arrarrarr', arr, this.videoUrl, this.defaultDefinition)
      this.vid = res.plVid
      this.playsafe = await this.$http.get(`/b/material/web/matVideo/playToken/${res.plVid}`, {
        headers: { token: this.studentData.token }
      })
      this.loadPlayer()
    },
    loadPlayer() {
      // console.log('this.play', this.playsafe, this.vid)
      const polyvPlayer = window.polyvPlayer
      this.player = polyvPlayer({
        wrap: '#player',
        width: '100%',
        height: '100%',
        vid: this.vid,
        showHd: true,
        // url: this.videoUrl,
        ban_history_time: 'off',
        df: 3,
        playsafe: this.playsafe,
        autoplay: false,
        watchStartTime: this.lastWatchTime,
        pictureInPicture: true // 画中画
      })
      const that = this
      that.player.HTML5.on('videoTimeupdate', function() {
        const rz = that.player.j2s_getCurrentTime()
        const videoTime = that.player && that.player.j2s_realPlayVideoTime ? that.player.j2s_realPlayVideoTime() : 0
        that.polvLastVideoTime = videoTime
        that.lastWatchTime = rz
        // console.log(
        //   'videoTimeupdate',
        //   that.polvStartWatchTime,
        //   that.lastWatchTime,
        //   that.lastWatchTime - that.polvStartWatchTime
        // )
        if (that.activityStatus === '2') {
          return
        }
        if (that.playbackData) {
          for (const item of that.playbackData) {
            if (Number(rz) > Number(item.dotTime) && Number(rz) < Number(item.dotTime) + 0.5) {
              that.subType = item.type
              const script = JSON.parse(item.script)
              that.examUrl = script.examUrl
              that.currentQuestionId = script.currentQuestionId
              that.getPaper(script)
            }
          }
        }
      })
      that.player.on('s2j_onPlayOver', (...params) => {
        console.log('当前视频播放完毕时触发', params)
        that.saveWatchTime()
      })
      that.player.on('s2j_onVideoSeek', (...params) => {
        console.log('视频拖拽进度时触发', params)
        if (params[0] > params[1]) {
          this.polvStartWatchTime = params[1]
        }
      })
    },
    // 获取资源列表
    async getResorce() {
      // console.log('进入了')
      this.resourceList = await this.$http.get('/b/classes/web/stu/schedule/resource/v2/' + this.studentData.scheduleId, {
        headers: { token: this.studentData.token }
      })
      console.log('this.resourceList', this.resourceList)
    },
    async savePolyWatchTime() {
      const scanEndTime = parseInt(new Date().getTime())
      const time = this.lastWatchTime - this.polvStartWatchTime
      const params = {
        activityId: this.videoData.activityId,
        classesId: this.studentData.classesId,
        scheduleId: this.studentData.scheduleId,
        planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
        state: this.videoData.activityStatus,
        startTimeStamp: this.scanBeginTime,
        endTimeStamp: scanEndTime,
        startTime: parseInt(this.polvStartWatchTime * 1000),
        endTime: parseInt(this.lastWatchTime * 1000),
        videoPlayedTime: parseInt(time * 1000),
        watchDuration: parseInt(time * 1000) > 60000 ? 60000 : parseInt(time * 1000)
      }
      if (time === 0 || time < 0) {
        return
      }
      this.polvStartWatchTime = this.lastWatchTime
      await this.$http.post(`/b/classes/live/v2/saveVideoProgressForPc`, params)
    },
    goAsk() {
      this.askVisible = true
    },
    refresh() {
      // console.log(this.$refs.postRef)
      this.askVisible = false
    },
    goEvaluate() {
      this.evaluateVisible = true
    },
    evaluatRefresh() {
      // console.log(this.$refs.postRef)
      this.evaluateVisible = false
      this.isShowEva = false
    }
  }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>
